import React from 'react'
import logger from '../../../../utils/logger'
import apiClient from '../../../../helper/Axios/axiosHelper'
import { toast } from 'react-toastify'

export const RenewAlert = ({ handleClose, objectToSend }) => {

const successToast = (text) => {

        toast.success(text, {
            autoClose: 2000
        })

    }

    const errorToast = (text) => {
        toast.error(text, {
            autoClose:2000
        })
    }


    const renewUser = async () => {
        try {

            if (objectToSend) {
                const renew = await apiClient.put(`Enrollment/Renew?enrollmentId=${objectToSend.enrollmentId}&memberId=${objectToSend.memberId}`)

                logger.warn('renewUser: ', renew)

                // if(renew.status === 200){
                //     successToast()
                // }
            }

        } catch (error) {
            logger.error(error);
            errorToast(error.message)

        }
    }

    return (
        <div className="modal-content contentWidhtRenovation">

            <div className="modal-body mbodyR-class">

                <div className="spanE-container">
                    <span className="material-symbols-outlined mI-error" aria-hidden="true" role="none">warning</span>
                </div>



                <p className="renovation-title">
                    Renovación
                </p>

                <p className="renovation-text">
                    ¿Estás seguro de que deseas <b>Renovar</b> la <b>Suscripción</b>?
                </p>

                <div className="btns-cancel-renovation">
                    <button className="btn-cancel btn-sr-cancel" data-bs-dismiss="modal"
                        aria-label="Close" id="cancelButton" onClick={handleClose}>Cancelar</button>
                    <button
                        className="btn-sr btn-sr-width btn btn-success"
                        id="saveButton"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {

                            handleClose();
                            renewUser()
                        }}
                    >Si, Renovar</button>
                </div>

            </div>
        </div>
    )
}
